export default __webpack_public_path__ + "static/media/8-min.40cee0a2.jpg";